import { State } from "../../types";

export type CountSubstringsAction = Readonly<{
  type: "COUNT SUBSTRINGS";
  substring: string;
}>;

export const CountSubstrings = (
  state: State,
  _action: CountSubstringsAction,
): State => {
  let substringInstances = 0
  
  Object.keys(state.blocks).forEach(key => {
    if (state.blocks[key].text) {
      const blockText : string = state.blocks[key].text;
      const wordToFindRegex = new RegExp(_action.substring, 'gi');
      const occurences = blockText.match(wordToFindRegex) ?? []
      substringInstances += occurences.length;
    }
  })
  return {
    ...state,
    substringInstances: substringInstances
  };
};
